exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog {\n  display: none;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  background-color: white;\n  padding: 20px;\n  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n}\n\n.dialog.error {\n  border: 2px solid red;\n}\n\n.dialog-header {\n  font-size: 1.5em;\n  margin-bottom: 10px;\n}\n\n.dialog-content {\n  margin-bottom: 20px;\n}\n\n.dialog-actions {\n  text-align: right;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /azp/_work/1/s/src/app/bi-reporting-config/data-dictionary/dataDictionary.component.css
// module id = ../../../../../src/app/bi-reporting-config/data-dictionary/dataDictionary.component.css
// module chunks = main